const PubSub = require('underpub-js')
const { gsap } = require('gsap/dist/gsap')
const { DrawSVGPlugin } = require('gsap/dist/DrawSVGPlugin')

gsap.registerPlugin(DrawSVGPlugin)

const loader = function (options) {
  this.options = {
    $el: false,
  }

  $.extend(true, this.options, options)

  this.data = {
    baseClass: 'comp-Loader',
    hasLoaded: false,
  }

  self.loaderTL
}

loader.prototype.init = function () {
  const self = this

  self.$loader = self.options.$el
  self.$loaderIcon = self.$loader.find(`.${self.data.baseClass}__icon`)
  self.loadTimeout = setTimeout(() => {
    if (self.data.hasLoaded) return

    self.animateOut()
  }, 5000)

  self.initTL()

  $(window).on('load', () => self.animateOut())
}

loader.prototype.initTL = function () {
  const self = this

  self.loaderTL = gsap
    .timeline({
      onComplete: () => {
        self.data.hasLoaded = true
        clearTimeout(self.loadTimeout)
      },
      delay: 0.5,
    })
    .to(self.$loaderIcon, {
      duration: 0.2,
      scale: 0,
      opacity: 0,
    })
    .to(self.$loader, {
      opacity: 0,
      expo: 'ease.inout',
      duration: 2,
    })
    .set(
      self.$loader,
      {
        pointerEvents: 'none',
      },
      '<',
    )
    .set([self.$loader, self.$loaderIcon], {
      visibility: 'hidden',
      display: 'none',
    })
}

loader.prototype.animateOut = function () {
  const self = this

  self.loaderTL.play()
}

module.exports = loader
